import { get, post } from '@/utils/apiBase.js'
// 订单title
const getOrderTitleList = option => {
  return get('/apis/mdorder/order_title_list', option)
}
const getOrderList = option => {
  // return get('/apis/mdorder/order_list', option)
  return get('/apis/mdorder/order_list_v2', option)
}
const getOrderDetail = option => {
  return get('/apis/mdorder/order_detail_v2', option)
  // return get('/apis/mdorder/order_detail', option)
  
}
const getMallOrderDetail = option => {
  return get('/apis/mall/order/detail_v2', option)
}
// 订单快照商品列表
const getOrderSnapshotProducts = option => {
  return get('/apis/mdorder/get_order_snapshot_products', option)
}
// 订单快照详情
const getOrderSnapshotDetail = option => {
  return get('/apis/mdorder/get_order_transaction_snapshot', option)
}
const getScheme = option => {
  return get('/apis/weixin_api/get_scheme', option)
}
const MallPreviewOrder = option => {
  return post('/mall/preview/order', option)
}
// 创建订单，获取pay_id --电商
const CreateOrder = option => {
  return post('/mall/order', option)
}

// 创建订单，获取pay_id --众筹
const CreateOrderPro = (option) => {
  return post('/main/add_back', option, {
    apiShow: false
  })
}

const OrderSendPay = option => {
  return post('/mall/order/sendpay', option)
}
// 获取payId
const OrderResetPay = option => {
  return post('/mall/order/resetpay', option)
}
// 获取支付成功信息
const payPay_success_api = option => {
  return get('/pay/pay_success_api', option)
}

//  微信点金计划商家小票页面获取支付成功信息
const goldPaySuccessInfo = option => {
  return get('/apis/mdpay/pay_info', option)
}

// 获取众筹解锁单详情
const getProLockOrderDetail = option => {
  return get('/apis/mdorder/get_md_order_gift', option)
}

// 获取众筹解锁单关联订单
const getProLockOrderRelateOrderList = option => {
  return get('/apis/mdorder/get_gift_order_by_modify_address', option)
}

// 解锁单修改地址
const modifyProLockOrderAddress = option => {
  return post('/apis/mdorder/modify_gift_order_address', option)
}

// 获取拆盒信息
const getOrderNeedPacks = option => {
  return get('/apis/mdorder/order_need_packs', option)
}

// 众筹盲盒拆盒
const postOpenPacks = option => {
  return post('/apis/mdorder/open_packs', option)
}

export default {
  getOrderTitleList,
  getOrderList,
  getOrderDetail,
  getScheme,
  getMallOrderDetail,
  getOrderSnapshotProducts,
  getOrderSnapshotDetail,
  MallPreviewOrder,
  CreateOrder,
  CreateOrderPro,
  OrderSendPay,
  OrderResetPay,
  payPay_success_api,
  goldPaySuccessInfo,
  getProLockOrderDetail,
  getProLockOrderRelateOrderList,
  modifyProLockOrderAddress,
  getOrderNeedPacks,
  postOpenPacks
}
